import { createAction } from 'Modules/core/redux';


const actionTypes = {
    LANGUAGE_CHANGED: 'LANGUAGE_CHANGED',
};

export { actionTypes as i18nActionTypes };

export const i18nActions = {
    languageChanged: createAction(actionTypes.LANGUAGE_CHANGED),
};
